import { useEffect } from 'react';

const useKeyboardNavigation = (nextImage, prevImage) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      // Only handle navigation if no input/textarea is focused
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      switch (event.key) {
        case 'ArrowRight':
        case ' ': // Spacebar
          event.preventDefault();
          nextImage();
          break;
        case 'ArrowLeft':
          event.preventDefault();
          prevImage();
          break;
        default:
          break;
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyPress);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [nextImage, prevImage]);
};

export default useKeyboardNavigation;

